module.exports = __webpack_public_path__ + "img/bg.65ce6bc0.png";